import { IChecklistItemsDatasource } from './../datasources/checklist_items_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import { IChecklistFilterAlgorithm } from '../strategies/checklist_filter_strategy';

angular.module('capability-ng-checklist').factory(
  'filterChecklistItemsCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngChecklistItemsDatasource: IChecklistItemsDatasource
  ): ICommand => {
    return defineCommand(
      'filterChecklistItemsCommand',
      (deferred: ng.IDeferred<IQuery[]>, filterAlgorithm: IChecklistFilterAlgorithm): void => {
        ngChecklistItemsDatasource.model.checklistFilter = filterAlgorithm;
        deferred.resolve(QueryMediator.runQueries(ngChecklistItemsDatasource));
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/lib/checklist/commands/filter_checklist_items_command.ts